import { useTranslation } from 'next-i18next';
import { Heading } from '@restworld/ui-ds-base';

export const Header = () => {
  const { t } = useTranslation();
  const title = t('job-application-page:my_applications');
  const subTitle = t('job-application-page:all_applications_in_one_view');
  return (
    <div className="flex flex-col lg:gap-0 gap-1 items-start">
      <Heading size={1} className="hidden lg:block">
        {title}
      </Heading>
      <Heading size={4} className="lg:hidden">
        {title}
      </Heading>
      {/* Desktop only: on a phone the subtitle pushed the first application below the fold. */}
      <Heading size={4} weight="normal" color="muted-foreground" className="hidden lg:block">
        {subTitle}
      </Heading>
    </div>
  );
};
